import { Component } from "@angular/core";

@Component({
    selector: "dodo-base-header",
    templateUrl: "./base-header.component.html",
    styleUrls: ["./base-header.component.scss"],
    standalone: false
})
export class BaseHeaderComponent {
	constructor() {}
}
